// extracted by mini-css-extract-plugin
export default {"create_topic__wrapper":"styles_create_topic__wrapper__G3zPe"};